import React, { useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Nav } from "Common/Components/Tab/Nav";
import Tab from "Common/Components/Tab/Tab";
import HeaderInfo from "./components/HeaderInfo";
import Conversation from "./components/conversation";
import PersonalInfo from "./components/PersonalInfo";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";
import Notes from "./components/Notes";
import Tasks from "./components/Tasks";
import { SocketProvider } from "context/socket";
interface DNDSettings {
  mode: string;
  origin: string;
}

interface Contact {
  _id?: string;
  name: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  timezone?: string;
  companyName?: string;
  locationId?: string;
  assignedUser?: string;
  companyWebsite?: string;
  cityName?: string;
  streetAddress?: string;
  country?: string;
  state?: string;
  zipCode?: string;
  tags?: string[];
  attachments?: string[];
  customFields?: any[];
  isDndEnabled?: boolean;
  dndPreferences?: DNDSettings;
  contactType?: string;
  birthDate?: string;
  createdAt?: string;
}
const ContactDetails = () => {
  const AppService = useAppServices();
  const { contactId } = useParams();
  const [contact, setContact] = useState<Contact | any>({});
  const [loading, setLoading] = useState<boolean>(true);

  const getContact = async () => {
    const { response, error } = await AppService.contact.get({
      query: `_id=${contactId}`,
    });
    if (response) {
      setContact(response.data);
      setLoading(false);
    } else {
      setContact({});
      setLoading(false);
    }
  };

   let pageLoad = true;
  const onload = () => {
    if (pageLoad) {
      getContact();
      pageLoad = false;
    }
  };

  useEffect(() => {
    onload();
  }, []);
  if (loading) return "loading...";
  return (
    <React.Fragment>
      <BreadCrumb title="Contact" pageTitle="Pages" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 relative">
        {/* Left Column (Tabs Area) */}
        <div className="lg:col-span-7 space-y-4 max-h-[calc(100vh_-_theme('height.header')_*_2.4)] overflow-y-auto pr-2">
          <Tab.Container defaultActiveKey="contactTabs">
            <div className="card relative">
              {/* Header */}
              <HeaderInfo className="card-body" contact={contact} />

              {/* Tabs Navigation (Fixed within scroll area) */}
              <div className="py-2 sticky top-0 bg-white dark:bg-zink-700 z-20 border-b border-slate-200 dark:border-zink-500">
                <Nav className="flex flex-wrap w-full text-sm font-medium text-center nav-tabs">
                  {[
                    { key: "contactTabs", label: "Contact Info" },
                    { key: "noteTabs", label: "Notes" },
                    { key: "taskTabs", label: "Tasks" },
                  ].map(({ key, label }) => (
                    <Nav.Item eventKey={key} className="group" key={key}>
                      <a
                        href="#!"
                        data-tab-toggle
                        data-target={key}
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500"
                      >
                        {label}
                      </a>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>

              {/* Tab Content */}
              <div className="mt-3">
                <Tab.Content>
                  <Tab.Pane eventKey="contactTabs">
                    <PersonalInfo contact={contact} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="noteTabs">
                    <Notes />
                  </Tab.Pane>
                  <Tab.Pane eventKey="taskTabs">
                    <Tasks />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>

        {/* Right Column (Conversation) */}
        <div className="lg:col-span-5">
          <div className="sticky top-24">
            <SocketProvider>
              <Conversation  contact={contact}/>
            </SocketProvider>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactDetails;
